import PropTypes from 'prop-types'

import { Box } from '@mui/material'

const propTypes = {
  children: PropTypes.node,
}

const RatesWrapperView = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', columnGap: theme => theme.spacing(3) }}>
      {children}
    </Box>
  )
}

RatesWrapperView.propTypes = propTypes

export default RatesWrapperView
